import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Nota } from '../models/';

@Injectable()
export class NotasService extends RESTService<any> {

  public alergia: Nota;

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getNota: obtiene el listado completo de alergias de un paciente
   * @param numeroExpediente: string
   * @return any
   */
  obtenerNotas(numeroExpediente: string, dniMedico: string, remavo: boolean): any {
    return this._http.post(environment.api_host + 'notas/obtenerNotas', {
      numeroExpediente: numeroExpediente,
      dniMedico: dniMedico,
      remavo: remavo,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * crearNota: obtiene el listado completo de alergias de un paciente
   * @param numeroExpediente: string
   * @return any
   */
  crearNota(dniMedico: string, fecha: string, comentario: string, numeroExpediente: string): any {
    return this._http.post(environment.api_host + 'notas/crearNota', {
      numeroExpediente: numeroExpediente,
      dniMedico: dniMedico,
      comentario: comentario,
      fecha: fecha,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * actualizarNota: obtiene el listado completo de alergias de un paciente
   * @param numeroExpediente: string
   * @return any
   */
  actualizarNota(fecha: string, comentario: string, idPostit: string): any {
    return this._http.post(environment.api_host + 'notas/actualizarNota', {
      comentario: comentario,
      fecha: fecha,
      idPostit: idPostit,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * actualizarNota: obtiene el listado completo de alergias de un paciente
   * @param numeroExpediente: string
   * @return any
   */
  borrarNota(idPostit: string): any {
    return this._http.post(environment.api_host + 'notas/borrarNota', {
      idPostit: idPostit,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
}



// WEBPACK FOOTER //
// ./src/services/notas.service.ts